import { Button, Card, Col, Form, Input, Row, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import styles from '../../index.module.scss';
import TranslateFormWrapper from '../../../TranslationForm';

export interface CategoryFormFieldsProps {
  fieldPrefix?: string;
  handleSetFile: any;
}

const CategoryFormFields = ({ fieldPrefix = '', handleSetFile }: CategoryFormFieldsProps) => (
  <Row>
    <Col span={12}>
      <Card title='General' className={styles.general}>
        <Form.Item
          label='name'
          name={`${fieldPrefix}name`}
        >
          <Input placeholder='Category name' />
        </Form.Item>

        <Form.Item
          label='description'
          name={`${fieldPrefix}categoryDescription`}
        >
          <Input.TextArea placeholder='Category description' />
        </Form.Item>

        <Form.Item
          label='Link'
          name={`${fieldPrefix}link`}
        >
          <Input placeholder='Category Link' />
        </Form.Item>

        <TranslateFormWrapper
          field={{ name: `${fieldPrefix}root`, key: `${fieldPrefix}root` }}
          items={[
            {
              name: 'name',
              label: 'Name',
              item: <Input placeholder='name translation' />,
            },
            {
              name: 'description',
              label: 'Description',
              item: <Input.TextArea placeholder='description translation' />,
            },
          ]}
        />
      </Card>
    </Col>
    <Col span={12}>
      <Card title='SEO'>
        <Form.Item
          label='Meta title'
          name={`${fieldPrefix}title`}
        >
          <Input placeholder='Meta title' />
        </Form.Item>
        <Form.Item
          label='Description'
          name={`${fieldPrefix}description`}
        >
          <Input.TextArea placeholder='Meta description' />
        </Form.Item>
        <Form.Item
          label='Keywords'
          name={`${fieldPrefix}keywords`}
        >
          <Input.TextArea placeholder='Keywords' />
        </Form.Item>
        <TranslateFormWrapper
          field={{ name: `${fieldPrefix}seoTranslation`, key: `${fieldPrefix}root` }}
          items={[
            {
              name: 'seoTitle',
              label: 'Title',
              item: <Input placeholder='title translation' />,
            },
            {
              name: 'seoDescription',
              label: 'Description',
              item: <Input.TextArea placeholder='description translation' />,
            },
            {
              name: 'seoKeywords',
              label: 'Keywords',
              item: <Input.TextArea placeholder='keywords translation' />,
            },
          ]}
        />
      </Card>
    </Col>
    <Form.Item
      name='image'
    >
      <Upload
        name='file'
        onChange={handleSetFile}
      >
        <Button icon={<UploadOutlined />}>Upload</Button>
      </Upload>
    </Form.Item>
  </Row>
);

export default CategoryFormFields;
